import React from 'react'

const Chevron = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.64648 9.35359L6.35359 8.64648L12 14.2929L17.6465 8.64648L18.3536 9.35359L12 15.7071L5.64648 9.35359Z"
      // fill="black"
    />
  </svg>
)

export default Chevron
